// extracted by mini-css-extract-plugin
module.exports = {"container":"OptimizedImage_container__ZN2Fn","includeMargin":"OptimizedImage_includeMargin__gdXcW"};